import Vue from 'vue'
import VueRouter from 'vue-router'

const register = () => import('../views/register.vue')
const registerReg = () => import('../views/registerReg.vue')

const downloadV2 = () => import('../views/downloadV2.vue')
const mainIndex = () => import('../views/mainIndex.vue')
const page404 = () => import('../views/page404.vue')


const download = () => import('../views/download.vue')
const download2 = () => import('../views/download2.vue')
const html = () => import('../views/html.vue')
const loginLeague = () => import('../views/loginLeague.vue')


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    title: '首页',
    component: page404,
  },
  {
    path: '/register',
    name: 'register',
    title: '首页',
    meta: {
      title: '首页'
    },
    component: register
  },
  {
    path: '/registerReg',
    name: 'registerReg',
    title: '首页',
    meta: {
      title: '首页'
    },
    component: registerReg
  },
  {
    path: '/downloadV2',
    name: 'downloadV2',
    title: '首页',
    meta: {
      title: '首页'
    },
    component: downloadV2
  },
  {
    path: '/:ivcode',
    name: 'mainIndex',
    title: '首页',
    component: mainIndex,
    meta: {
      keepAlive: true
    },
  },
  {
    path: '/download',
    name: 'download',
    title: '下载',
    component: download
  },
  {
    path: '/download2',
    name: 'download2',
    title: '下载',
    component: download2
  },
  {
    path: '/old_login',
    name: 'oldLogin',
    title: 'old_login',
    component: loginLeague
  },
  {
    path: '/html',
    name: 'html',
    title: 'html',
    component: html
  },
  {
    // 会匹配所有路径
    path: '*',
    component: page404
  },
  {
    // 会匹配所有路径
    path: '/*/*',
    component: page404
  }
]

const router = new VueRouter({
  mode: 'history',
  prefetch: false, // 禁用prefetch
  routes
})

router.beforeEach((to, from, next) => {
  // console.log('to.matched.length ', to.matched, to.matched.length)
  // // eslint-disable-next-line no-debugger
  // debugger
  if (to.query.token) {
    sessionStorage.setItem('token', `Bearer ${to.query.token}`)
  } else if(from.query.token) {
    sessionStorage.setItem('token', `Bearer ${from.query.token}`)
  }

  if (to.query.chlCode) {
    sessionStorage.setItem('chlCode', to.query.chlCode)
  } else if(from.query.chlCode) {
    sessionStorage.setItem('chlCode', from.query.chlCode)
  }
  
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '首页'
  }
  next()
})

export default router
